<template>
  <div
    class="inline-flex w-fit bg-black text-white opacity-90 py-1 px-2 rounded-lg gap-1 tablet:gap-8"
  >
    <slot></slot>
  </div>
</template>
